import React from 'react';
import { ShieldCheck, Clock, Award, Star } from 'lucide-react';
export function TrustBar() {
  const items = [{
    Icon: ShieldCheck,
    label: 'Licensed & Insured',
    sub: 'in Michigan'
  }, {
    Icon: Award,
    label: 'Premium Shingles',
    sub: 'Top brands installed'
  }, {
    Icon: Clock,
    label: 'On-Time, Every Time',
    sub: 'No missed appointments'
  }, {
    Icon: Star,
    label: '5-Star Local Reviews',
    sub: 'Trusted by neighbors'
  }];
  return <section className="bg-white border-b border-slate-100" data-id="element-351">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-352">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-353">
          {items.map(({
          Icon,
          label,
          sub
        }) => <div key={label} className="flex flex-col items-center text-center px-2" data-id="element-354">
              <Icon className="w-9 h-9 text-[#2DB8E0] mb-2" data-id="element-355" />
              <span className="font-bold text-[#1a2332]" data-id="element-356">{label}</span>
              <span className="text-sm text-slate-500" data-id="element-357">{sub}</span>
            </div>)}
        </div>
      </div>
    </section>;
}